import { Box, Button, Typography } from '@mui/material';
import React from 'react';

/**
 * Captura exceções de render da tela filha. Sem isso, no iOS (PWA) o erro vira
 * tela totalmente branca. Mostra a mensagem do erro para o usuário reportar.
 * Use `key` (ex.: pathname) para zerar o erro ao trocar de rota.
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary:', error, info && info.componentStack);
    }

    render() {
        const { error } = this.state;
        if (!error) return this.props.children;

        return (
            <Box sx={{ p: 3, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                <Typography variant="h6" component="h2">Algo deu errado ao abrir esta tela</Typography>
                <Typography variant="body2" color="text.secondary">
                    Tente recarregar. Se o problema continuar, informe o texto abaixo ao suporte.
                </Typography>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: 11, wordBreak: 'break-word', maxWidth: '100%' }}
                >
                    {String((error && error.message) || error)}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <Button variant="contained" onClick={() => window.location.reload()}>Recarregar</Button>
                    <Button variant="outlined" onClick={() => { window.location.href = '/home'; }}>Ir para o início</Button>
                </Box>
            </Box>
        );
    }
}
